import React, { useEffect } from 'react'
import { useState } from 'react'
import { Grid, Box, Button, Typography, TextField, FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CircularProgress, Backdrop } from '@mui/material';
import LoadScheddingBlock from '../../../components/loadsheddingblock/loadscheddingblock'
// import './LoadManagement.scss'
import "../../GeneralServices/NewConnection/NewConnectionForm.scss"
import Error from '../../../components/error/error';
import { dBillAPI } from '../../../services/Functions';
import { useSelector } from 'react-redux';
import { cpBaseUrl } from '../../../network/urls';

const LoadManagement = () => {

    const initialValues = {
        iv_reference_number: '',
        iv_consumer_id: ''
    }

    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [error, setError] = useState('')

    const [referenceNumber, setReferenceNumber] = useState('');

    const [searchBy, setSearchBy] = useState('consumerId');
    const { token } = useSelector((state) => state.auth);
    const SearchBy = (event) => {
        values.iv_search_by = event.target.value;
        setSearchBy(event.target.value);
        values.iv_consumer_id = ''
        values.iv_reference_number = ''
        setReferenceNumber('');
        setLoadScheddingData()
    };

    //const [loadScheddingData, setLoadScheddingData] = useState()
    const [loadScheddingData, setLoadScheddingData] = useState()

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_reference_number: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'referenceNo',
                then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
                otherwise: Yup.string().optional()
            }),
            iv_consumer_id: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'consumerId',
                then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
                otherwise: Yup.string().optional()
            }),
        }),
        onSubmit: async (values, { resetForm }) => {
            if (searchBy === 'referenceNo') {
                setViewBackdrop(true)
                let requestOptions = {
                    method: 'GET',
                    redirect: 'follow',
                };

                await fetch(cpBaseUrl + "?refno=" + values.iv_reference_number, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.tblStatus[0].status === true) {
                            let feederCode = result.Table[0].FEEDERCD
                            let myHeaders = new Headers();
                            myHeaders.append("Cookie", "ccms_session=eyJpdiI6IndJaUpBUDduQVUybVJwTWJ2WCtERkE9PSIsInZhbHVlIjoiNGhlaXRWdlY2cWh0bnFiUldRcklqb1lPWExZQ3BjZ2t1dlpPOGduQUs1ZzhOeTcyejZXU0U3ekpaVXNKSVZ2aiIsIm1hYyI6IjM3NThlMjJhNjk2NWQ0NjdiY2ZiM2NlY2FkN2FkNmM0OWY5ODkzYjAwZDA5ZmMzZWFkZDNhOGQzZmVlM2Q5MjgifQ%3D%3D");
                            let requestOptions = {
                                method: 'GET',
                                headers: myHeaders,
                                headers: myHeaders,
                                redirect: 'follow',
                            };

                            fetch("https://ccms.pitc.com.pk/api/search_feeder_schedule?feeder_code=" + feederCode + "&disco_code=" + values.iv_reference_number.slice(2, 4) + "000", requestOptions)
                                .then(response => response.json())
                                .then(result => {
                                    setLoadScheddingData(result.server_response[0])
                                    setViewBackdrop(false)
                                })
                                .catch(error => console.log('error', error));
                        }
                        else {
                            setError('Reference number not exists!')
                            setViewBackdrop(false)

                        }
                    }
                    )
                    .catch(error => console.log('error', error));
            }
            else if (searchBy === 'consumerId') {
                setViewBackdrop(true)
                let apiResponse = await dBillAPI(token, values.iv_consumer_id)
                if (apiResponse.status) {
                    let referenceNo = apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14)
                    let requestOptions = {
                        method: 'GET',
                        redirect: 'follow',
                    };

                    await fetch(cpBaseUrl + "?refno=" + referenceNo, requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.tblStatus[0].status === true) {
                                let feederCode = result.Table[0].FEEDERCD
                                let myHeaders = new Headers();
                                myHeaders.append("Cookie", "ccms_session=eyJpdiI6IndJaUpBUDduQVUybVJwTWJ2WCtERkE9PSIsInZhbHVlIjoiNGhlaXRWdlY2cWh0bnFiUldRcklqb1lPWExZQ3BjZ2t1dlpPOGduQUs1ZzhOeTcyejZXU0U3ekpaVXNKSVZ2aiIsIm1hYyI6IjM3NThlMjJhNjk2NWQ0NjdiY2ZiM2NlY2FkN2FkNmM0OWY5ODkzYjAwZDA5ZmMzZWFkZDNhOGQzZmVlM2Q5MjgifQ%3D%3D");
                                let requestOptions = {
                                    method: 'GET',
                                    headers: myHeaders,
                                    headers: myHeaders,
                                    redirect: 'follow',
                                };

                                fetch("https://ccms.pitc.com.pk/api/search_feeder_schedule?feeder_code=" + feederCode + "&disco_code=" + referenceNo.slice(2, 4) + "000", requestOptions)
                                    .then(response => response.json())
                                    .then(result => {
                                        setLoadScheddingData(result.server_response[0])
                                        setViewBackdrop(false)
                                    })
                                    .catch(error => console.log('error', error));
                            }
                            else {
                                setError('Customer ID. does not exists!')
                                setViewBackdrop(false)
                            }
                        }
                        )
                        .catch(error => console.log('error', error));
                } else {
                    setError('Customer ID. not found!')
                    setViewBackdrop(false)
                }
            }
        }
    })

    useEffect(() => {
        if (values.iv_reference_number.length < 14) {
            setLoadScheddingData()
        }
    }, [values.iv_reference_number])

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent default form submission
            handleSubmit(); // Manually call the submit function
        }
    };

    const errorCloses = () => {
        setError('')
    }

    return (
        <>
            <Grid container className='nC'>
                <Box className='nCContainer'>
                    <div className="headingBarDiv">
                        <h3 className="heading">
                            Load Shedding Schedule
                        </h3>
                    </div>
                    <form className='ncform'>
                        <Typography variant="h6" className="groupTitle">
                            <div className="redCell">
                            </div>
                            Connection Details
                        </Typography>
                        <Grid container className='container'>
                            <Grid item lg={3} sx={{ paddingRight: '20px' }}>
                                <Typography className="fieldLabel"> Search By</Typography>
                                <FormControl className="form-control"  >
                                    <RadioGroup
                                        className="radio-group"
                                        row
                                        name="iv_search_by"
                                        defaultValue={searchBy}
                                        value={searchBy}
                                        onChange={SearchBy}
                                    >
                                        <FormControlLabel
                                            value="consumerId"
                                            className="form-control-label"
                                            control={<Radio />}
                                            label="Customer ID."
                                            name="consumerId"
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            value="referenceNo"
                                            className="form-control-label"
                                            control={<Radio />}
                                            label="Reference No."
                                            name="referenceNo"
                                            labelPlacement="end"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {
                                searchBy === 'consumerId' &&
                                <Grid item lg={2} sx={{ paddingRight: '20px' }}>
                                    <Typography className='fieldLabel' >Customer ID.</Typography>
                                    <TextField
                                        inputProps={{ maxLength: 10 }}
                                        required
                                        type='text'
                                        autoComplete='off'
                                        name="iv_consumer_id"
                                        value={values.iv_consumer_id}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onKeyPress={handleKeyPress}
                                        id="iv_consumer_id"
                                        className='textInputField'
                                    />
                                    <Box className='from-Error'>
                                        {errors.iv_consumer_id && touched.iv_consumer_id ? (errors.iv_consumer_id) : null}
                                    </Box>
                                </Grid>
                            }
                            {
                                searchBy === 'referenceNo' &&
                                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                                    <Typography className='fieldLabel' >Reference No.</Typography>
                                    <TextField
                                        inputProps={{ maxLength: 14 }}
                                        required
                                        type='text'
                                        autoComplete='off'
                                        name="iv_reference_number"
                                        value={values.iv_reference_number}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onKeyPress={handleKeyPress}
                                        id="iv_reference_number"
                                        className='textInputField'
                                    />
                                    <Box className='from-Error'>
                                        {errors.iv_reference_number && touched.iv_reference_number ? (errors.iv_reference_number) : null}
                                    </Box>
                                </Grid>
                            }
                            <Grid item lg={2} sx={{ paddingRight: '20px',display:'flex' }}>
                                <Button variant="contained" component="label" type='submit' onClick={handleSubmit}
                                    sx={{
                                        fontSize: 'small',
                                        height: 40,
                                        boxShadow: 'none',
                                        textTransform: 'capitalize'
                                    }}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container >
                            <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                                {
                                    error &&
                                    <Error
                                        error={error}
                                        onClose={() => errorCloses()}
                                        backgroundColor="#FFC0CB"
                                        textColor="#bb0303"
                                        iconColor="#bb0303"
                                    />
                                }
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ margin: '10px 20px' }}>
                            <Grid item lg={4} xs={4} className='item' sx={{ border: 1, borderColor: 'darkGrey', borderRadius: '5px 0px 0px 5px', backgroundColor: 'lightGrey' }}>
                                <Typography variant="p">Feeder:</Typography>
                                <Typography variant="p" className='detail'>{loadScheddingData ? loadScheddingData.Feeder : '-'}</Typography>
                            </Grid>
                            <Grid item lg={4} xs={4} className='item' sx={{ border: 1, borderColor: 'darkGrey', backgroundColor: 'lightGrey' }}>
                                <Typography variant="p">Grid:</Typography>
                                <Typography variant="p" className='detail'>{loadScheddingData ? loadScheddingData.Grid : '-'}</Typography>
                            </Grid>
                            <Grid item lg={4} xs={4} className='item' sx={{ border: 1, borderColor: 'darkGrey', borderRadius: '0px 5px 5px 0px', backgroundColor: 'lightGrey' }}>
                                <Typography variant="p">Feeder Status:</Typography>
                                <Typography variant="p" className='detail'>{loadScheddingData ? loadScheddingData.Feeder_Status : '-'}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ margin: '10px 20px' }}>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='01' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[0] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='02' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[1] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='03' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[2] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='04' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[3] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='05' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[4] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='06' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[5] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='07' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[6] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='08' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[7] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='09' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[8] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='10' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[9] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='11' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[10] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='12' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[11] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='13' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[12] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='14' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[13] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='15' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[14] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='16' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[15] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='17' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[16] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='18' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[17] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='19' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[18] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='20' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[19] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='21' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[20] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='22' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[21] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='23' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[22] : -1} />
                            </Grid>
                            <Grid item lg={2} xs={2}>
                                <LoadScheddingBlock number='24' lightStatus={loadScheddingData ? loadScheddingData.planned_sch[23] : -1} />
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </Grid>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default LoadManagement
